import {Component, EventEmitter, Input, Output} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {AccessRequest} from '../models/access-request';

@Component({
  selector: 'register-form',
  template: `
    <form *ngIf="!registered" (ngSubmit)="register()">
      <div class="form-group"
           [ngClass]="{'has-error':!registrationForm.controls['firstname'].valid && registrationForm.controls['firstname'].touched}">
        <label>First Name*</label>
        <input class="form-control form-control-sm" [formControl]="registrationForm.controls['firstname']">
      </div>
      <div class="form-group"
           [ngClass]="{'has-error':!registrationForm.controls['lastname'].valid && registrationForm.controls['lastname'].touched}">
        <label>Last Name*</label>
        <input class="form-control form-control-sm" [formControl]="registrationForm.controls['lastname']">
      </div>
      <div class="form-group"
           [ngClass]="{'has-error':!registrationForm.controls['email'].valid && registrationForm.controls['email'].touched}">
        <label>Email Address*</label>
        <input class="form-control form-control-sm" [formControl]="registrationForm.controls['email']">
      </div>
      <div class="form-group"
           [ngClass]="{'has-error':!registrationForm.controls['phone'].valid && registrationForm.controls['phone'].touched}">
        <label>Telephone*</label>
        <input class="form-control form-control-sm" [formControl]="registrationForm.controls['phone']">
      </div>
      <div class="form-group">
        <label>Company Name</label>
        <input class="form-control form-control-sm" [formControl]="registrationForm.controls['company']">
      </div>
      <button class="btn btn-sm btn-outline-primary btn-block" [disabled]="working">
        <span *ngIf="!working">Request Access</span>
        <span *ngIf="working">Requesting Access</span>
      </button>
    </form>
  `,
  styles: []
})
export class RegisterFormComponent {

  @Input() registered: boolean;
  @Input() working: boolean;
  @Output() submitRegistration: EventEmitter<AccessRequest> = new EventEmitter();
  public registrationForm: FormGroup;

  constructor(fb: FormBuilder) {
    this.registrationForm = fb.group({
      'firstname': [null, Validators.required],
      'lastname': [null, Validators.required],
      'email': [null, Validators.required],
      'phone': [null, Validators.required],
      'company': [null]
    });
  }

  register() {
    if (!this.registrationForm.valid) {
      this.registrationForm.controls['firstname'].markAsTouched();
      this.registrationForm.controls['lastname'].markAsTouched();
      this.registrationForm.controls['phone'].markAsTouched();
      this.registrationForm.controls['email'].markAsTouched();
      return;
    }

    const ar: AccessRequest = this.registrationForm.value as AccessRequest;
    this.submitRegistration.emit(ar);
  }
}



// WEBPACK FOOTER //
// C:/Users/jstan/Projects/usda-document-client/src/app/modules/core/components/register-form.ts